import { useMemo } from 'react';
import { ReferralData, FilterConfiguration } from 'components/LMA/types';
import { FilterValues } from 'components/LMA/ActiveFilters';
import { filterService } from 'components/LMA/services';

interface UseFilteredDataParams {
  data: ReferralData[];
  filters: FilterValues;
  filterConfig?: FilterConfiguration;
}

/**
 * Hook for filtering referral data
 *
 * This hook uses the filterService which can be easily swapped between
 * client-side and API-based filtering implementations.
 *
 * The filtering is now dynamic based on FilterConfiguration from Sitecore.
 * Any new filters added in Sitecore config will automatically work without code changes.
 *
 * Currently uses client-side filtering. To switch to API filtering:
 * 1. Update filterService to use ApiFilterService instead of ClientSideFilterService
 * 2. Make this hook async and handle the Promise
 * 3. No component changes needed as the interface remains the same
 */
export const useFilteredData = ({ data, filters, filterConfig }: UseFilteredDataParams) => {
  return useMemo(() => {
    return filterService.filterData(data, filters, filterConfig);
  }, [data, filters, filterConfig]);
};
